let configsFactory = function ($q, HomeService) {
    let getConfigs = () => {
        const defer = $q.defer();
        HomeService.configs()
            .then((res) => {
                return defer.resolve(res)
            })
        return defer.promise;
    }

    let setEnvironmentConfig = (obj) => {
        this.UIConfig = obj;
    }

    let getEnvironmentConfig = () => {
        return this.UIConfig;
    }

    let setPermissionConfig = (obj) => {
        this.permissionConfig = obj;
    }

    let getPermissionConfig = () => {
        return this.permissionConfig;
    }

    return {
        getConfigs,
        setEnvironmentConfig,
        getEnvironmentConfig,
        setPermissionConfig,
        getPermissionConfig
    }
}

configsFactory.$inject = ['$q', 'HomeService'];

export default configsFactory;


// WEBPACK FOOTER //
// ./client/app/common/configs/configs.factory.js